module.exports = __webpack_public_path__ + "img/angst-behandeling-foto.3e3fe2b2.jpg";